let defaultFormValues = {
  display: {
    fadeIn: 3500,
    fadeOut: 3000,
    displayDuration: 30000,
    minEdge: 0.08,
    minComment: 0.09,
    scoreSizeRatio: 0.15,
    rotationRate: 4500,
    randomizeInitialDirection: false,
    activeCommentsOrder: 'TIMEDESC',
    activeParticules: false,
    displayTitle: true,
    backgroundColor: '#2C2E42',
    fontColor: '#f5f5f5',
    secondaryColor: '#4EA3AD',
  },
  query: {
    sites: [],
    languages: [],
    scoreMin: 115,
    scoreMax: 300,
    limit: 400,
    histopadRating: [],
    visitRating: [],
  },
  bookmarkId: null,
  queryType: 'QUERY',
  name: '',
}

export default defaultFormValues
